/**
 *
 * @param {string} reportName user-provided name e.g. Andrew's Shopper Analysis
 * @param {string} tabName name of tab in focus e.g. Histogram Chart
 * @returns {string} chart title to display
 */
export const getExportName = ({ reportName = '', tabName = '' }) => {
  if (reportName === '' && tabName === '') {
    return '';
  }
  return `${reportName} - ${tabName}`;
};
